import rootLogger from '@/utils/root-logger';
import fetcher from '@/utils/fetcher';

const logger = rootLogger.create('vuex-modules/g2w-registration');

const mutations = {
  setFields(state, payload) {
    state.fields = payload.fields;
  },

  setQuestions(state, payload) {
    state.questions = payload.questions;
  },

  setRegistrant(state, payload) {
    state.registrant = payload.registrant;
  }
};

const actions = {
  getRegistrationFields({commit, rootGetters}, payload) {
    const operation = 'getRegistrationFields';
    const webinarKey = payload.webinarKey;
    logger.log(operation, { webinarKey });

    if (payload.stub) {
      return Promise.resolve(JSON.parse('{"fields":[{"required":true,"maxSize":128,"field":"firstName"},{"required":true,"maxSize":128,"field":"lastName"},{"required":true,"maxSize":128,"field":"email"}],"questions":[]}'));
    }

    const path = `/api/webinars/${webinarKey}/registration`;
    const url = rootGetters['g2wEnv/globalUrl'](path);

    return fetcher.fetchJSON(url, {}, {operation})
      .then((registrationFields) => {
        commit('setFields', {fields: registrationFields.fields});
        commit('setQuestions', {questions: registrationFields.questions});
        return registrationFields;
      });
  },

  async registerForWebinar({rootGetters}, payload) {
    const operation = 'registerForWebinar';
    const webinarKey = payload.webinarKey;
    const data = payload.data;
    logger.log(operation, {webinarKey, data});

    const fetchParams = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(data)
    };

    const path = `/api/webinars/${webinarKey}/registrants`;
    const url = rootGetters['g2wEnv/globalUrl'](path);

    return fetcher.fetchJSON(url, fetchParams, {operation, quiet: true});
  }
};

const state = () => ({
  fields: [],
  questions: [],
  registrant: null
});

export default {
  namespaced: true,
  mutations,
  actions,
  state
};
